import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    @import '~antd/dist/antd.css';
  }

  html {
    scroll-behavior: smooth;

    @media (max-width: 1080px) {
      font-size: 93.75%;
    }

    @media (max-width: 720px) {
      font-size: 87.5%;
    }
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    background: ${props => `linear-gradient(129deg, ${props.theme.background1} 35%, ${props.theme.background2} 100%)`};
    -webkit-font-smoothing: antialiased;
  }

  body, input, textarea, button {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
  }

  h1, h2, h3, h4, h5, h6, strong { 
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
  }

  h1, h2 {
    background: -webkit-linear-gradient(left, #13B0F5, #E70FAA);
    background: -o-linear-gradient(right, #13B0F5, #E70FAA);
    background: -moz-linear-gradient(right, #13B0F5, #E70FAA);
    background: linear-gradient(to right, #13B0F5, #E70FAA); 
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  h1{
    font-size: 50px;
    @media (max-width: 480px) {
      font-size: 40px;
    }
    
  }
  h2 {
    font-size: 58px;
    @media (max-width: 480px) {
      font-size: 35px;
    }
  }

  
  button {
    cursor: pointer;
  }

  [disable] {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .react-modal-overlay {
    background: rgba(0,0,0,0.5);

    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .react-modal-content {
    width: 100%;
    max-width: 576px;
    background: var(--background);
    padding: 3rem;
    position: relative;
    border-radius: 0.24rem;
  }

  .react-modal-close {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
    border: 0;
    background: transparent;

    transition: filter 0.2s;

    &:hover {
      filter: brightness(0.8);
    }
  }
`